import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { ArrowRight } from "lucide-react";

function BannerGeneral() {
  return (
    <div className="bg-gray-200 relative py-20 overflow-hidden">
      {/* 🔵 SVG Decorativo 1 (diagonales) */}
      <motion.div
        className="absolute left-[10%] top-[25%] "
        initial={{ scale: 0, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 0.3 }}
        transition={{ duration: 4 }}
      >
        <svg
          className="w-32 h-32 text-[#febe10]"
          viewBox="0 0 200 200"
          fill="none"
        >
          <line
            x1="20"
            y1="180"
            x2="180"
            y2="20"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <line
            x1="60"
            y1="200"
            x2="200"
            y2="60"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            opacity="0.5"
          />
        </svg>
      </motion.div>

      {/* 🔵 SVG Decorativo 2 (diagonales) */}
      <motion.div
        className="absolute right-[10%] top-[30%] "
        initial={{ scale: 0, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 0.3 }}
        transition={{ duration: 4, delay: 0.2 }}
      >
        <svg
          className="w-32 h-32 text-[#007bff]"
          viewBox="0 0 200 200"
          fill="none"
        >
          <line
            x1="20"
            y1="180"
            x2="180"
            y2="20"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <line
            x1="60"
            y1="200"
            x2="200"
            y2="60"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            opacity="0.5"
          />
        </svg>
      </motion.div>

      {/* 🧠 CONTENIDO */}
      <div className="max-w-6xl mx-auto px-4 relative z-10">
        {/* Lema */}
        <div className="max-w-3xl mx-auto pb-16">
          <motion.p
            className="text-[#004270] text-2xl md:text-3xl leading-none"
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ type: "spring", stiffness: 100 }}
          >
            ¡Únete a la UTPL y
          </motion.p>

          <motion.p
            className=" font-montserrat text-[#febe10] m-0 p-0 font-black text-5xl md:text-7xl text-center leading-[0.8]"
            initial={{ scale: 0, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", delay: 0.5, stiffness: 200 }}
          >
            decide ser más
          </motion.p>

          <motion.p
            className="text-right text-lg md:text-2xl leading-none"
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ type: "spring", delay: 1, stiffness: 100 }}
          >
            en la universidad <b>más innovadora del Ecuador!</b>
          </motion.p>
        </div>

        {/* Secciones */}
        <div className="flex flex-col md:flex-row gap-10">
          {/* Item */}
          <div className="flex-1 text-center space-y-4">
            <motion.h2
              className="text-lg md:text-xl m-0 p-0"
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
            >
              Ya te decidiste
            </motion.h2>

            <motion.div
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              <NavLink
                to="/oferta"
                className=" inline-flex hover:text-white items-center gap-2 border border-[#febe10] rounded-xl px-6 py-2 text-[#004270] font-bold hover:bg-[#febe10] hover:scale-105 transition"
              >
                Oferta académica
                <ArrowRight size={18} />
              </NavLink>
            </motion.div>
          </div>

          {/* Item */}
          <div className="flex-1 text-center space-y-4">
            <motion.h2
              className="text-lg md:text-xl m-0 p-0"
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
            >
              Más información
            </motion.h2>

            <motion.div
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              <a
                href="https://wa.me/593999565400"
                className="inline-flex items-center gap-2 border border-[#febe10] rounded-xl px-6 py-2 text-[#004270] font-bold hover:bg-[#febe10] hover:text-white hover:scale-105 transition"
              >
                Escríbenos
                <ArrowRight size={18} />
              </a>
            </motion.div>
          </div>

          {/* Item */}
          <div className="flex-1 text-center space-y-4">
            <motion.h2
              className="text-lg md:text-xl m-0 p-0"
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
            >
              Más motivación
            </motion.h2>

            <motion.div
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              <a
                href="https://www.youtube.com/watch?v=FLuQ5B9Z7Uc"
                className=" inline-flex items-center gap-2 border border-[#febe10] rounded-xl px-6 py-2 text-[#004270] font-bold hover:bg-[#febe10] hover:text-white hover:scale-105 transition"
              >
                Historias de éxito
                <ArrowRight size={18} />
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BannerGeneral;
